import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=5e4d331e&scoped=true&"
import script from "./EditCard.vue?vue&type=script&lang=js&"
export * from "./EditCard.vue?vue&type=script&lang=js&"
import style0 from "./EditCard.vue?vue&type=style&index=0&id=5e4d331e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d331e",
  null
  
)

export default component.exports